export const SKIN_CARE_PRODUCT_CODE = "SCPR" as const;
export const BOTOX_FREE_PRODUCT_CODE = "FREE-BOT01FAL" as const;
